<script lang="ts" setup>
import {
  BlockCarouselImageSelectFields,
  BlockCarouselManualFields,
  BlockCoverNavigationFields,
  BlockCoverPaletteFields,
  BlockCoverUPSFields,
  BlockCoverVariantsFields,
  BlockFooterCTAFields,
  BlockImageTextFields,
  BlockSingleQuoteFields,
} from '~/utils/CmsBlockFields'

const { $directus, $readItems, $readItem } = useNuxtApp()
const { t } = useI18n()
const route = useRoute()

const { data, error } = await useAsyncData('cover_detail', async () => {
  const covers = await $directus.request($readItems('covers', {
    filter: {
      slug: {
        _eq: route.params.slug,
      },
      status: {
        _eq: 'published',
      },
    },
  }))
  if (covers.length === 0) {
    console.error('Pool not found')
    throw createError({
      statusCode: 404,
      message: 'no published pool with that slug found',
    })
  }

  return await $directus.request($readItem('covers', covers[0]?.id, {
    fields: [
      'id',
      'slug',
      {
        seo: ['*', {
          translations: ['*'],
        }],
        page_translations: ['*'],
        hero_image: ['*'],
        hero_video: ['*'],
        tech_specs: ['*', {
          cover_tech_spec_id: ['*', {
            translations: ['*'],
          }],
        }],

        blocks: [
          'collection',
          'id',
          {
            item: {
              block_carousel_manual: BlockCarouselManualFields, //
              block_cover_navigation: BlockCoverNavigationFields, //
              block_single_quote: BlockSingleQuoteFields, //
              block_image_text: BlockImageTextFields, //
              block_footer_cta: BlockFooterCTAFields, //
              // Cover Detail Specific
              block_cover_ups: BlockCoverUPSFields,
              block_cover_variants: BlockCoverVariantsFields,
              block_cover_palette: BlockCoverPaletteFields,
              block_carousel_image_select: BlockCarouselImageSelectFields,
            },
          },
        ],
      },
    ],
  }))
})

if (error.value) {
  throw createError({
    fatal: true,
    statusCode: 404,
    message: 'Cover not found',
  })
}
</script>

<template>
  <div>
    <HeroDetail
      :data="{
        hero_image: data?.hero_image,
        hero_video: data?.hero_video,
        translations: data?.page_translations,
      } as any
      "
      :back-button="{
        text: t('general.back_to_overview'),
        link: '/pools',
      }"
    />
    <div>
      <div v-for="block in data?.blocks" :key="block.id">
        <BlockPoolNavigation v-if="block.collection === 'block_cover_navigation'" />
        <BlockSingleQuote v-if="block.collection === 'block_single_quote'" :data="block.item" />
        <BlockImageText v-if="block.collection === 'block_image_text'" :data="block.item" />
        <BlockCarouselManual v-if="block.collection === 'block_carousel_manual'" :data="block.item" />
        <BlockFooterCTA v-if="block.collection === 'block_footer_cta'" :data="block.item" />
        <!-- Cover Detail Specific -->
        <BlockPoolUPS v-if="block.collection === 'block_cover_ups'" :data="block.item" />
        <BlockPoolVariants v-if="block.collection === 'block_cover_variants'" :specs="data?.tech_specs!" :data="block.item" />
        <BlockPoolPalette v-if="block.collection === 'block_cover_palette'" :data="block.item" />
        <BlockCarouselImageSelect v-if="block.collection === 'block_carousel_image_select'" :data="block.item" />
      </div>
    </div>
  </div>
</template>

<style>

</style>
